import { useEffect, useState } from 'react'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { useAsyncCallback } from '../../../../../hooks'
import { getProfileUserTooltip } from '../../../../User'

export function useProfileUserInfoTooltipData({
  enabled,
  isOpen,
  userId,
} = EMPTY_OBJECT) {
  const [userInfoTooltipData, setUserInfoTooltipData] = useState(null)
  const [userInfoTooltipUserId, setUserInfoTooltipUserId] = useState(null)
  const [prevIsOpen, setPrevIsOpen] = useState(isOpen)

  // resets tooltip data when closed, during render
  if (isOpen !== prevIsOpen) {
    setPrevIsOpen(isOpen)

    if (!isOpen) {
      setUserInfoTooltipData(null)
      setUserInfoTooltipUserId(null)
    }
  }

  const fetchUserInfoTooltip = useAsyncCallback(() => {
    setUserInfoTooltipUserId(userId)
    setUserInfoTooltipData(null)

    return getProfileUserTooltip(userId)
      .then(response => {
        if (response?.data) {
          setUserInfoTooltipData(response.data)
        }

        return response
      })
      .catch(console.error)
  }, [userId])

  useEffect(() => {
    if (enabled && isOpen && userId) {
      fetchUserInfoTooltip()
    }
  }, [enabled, isOpen, userId])

  return {
    userInfoTooltipData,
    userInfoTooltipUserId,
  }
}
